const codeOf = (reason: string): number | null => {
  const match = /(\d{3})/.exec(reason);
  return match ? Number(match[1]) : null;
};

export const sipRejectionDetail = (reason: string): string => {
  const code = codeOf(reason);
  if (code === null) return 'Your phone system rejected the call.';

  const suffix = ` (SIP ${code}).`;
  if ([401, 403, 407].includes(code)) {
    return `Your phone system refused the call${suffix} If it is a carrier or SIP trunk ` +
      "provider, its IP authentication must allow Twilio's addresses — they are listed in " +
      'CallScribe settings → Phone system. If it is a PBX, check the username and password.';
  }
  if ([404, 484, 604].includes(code)) {
    return `Your phone system did not recognise the number${suffix}`;
  }
  if ([480, 486, 600, 603].includes(code)) {
    return `Your phone system could not reach the number or declined the call${suffix}`;
  }
  if (code === 408) {
    return 'Your phone system did not answer in time (SIP 408).';
  }
  if (code >= 500 && code <= 599) {
    return `Your phone system reported an error${suffix}`;
  }
  return `Your phone system returned SIP ${code}.`;
};

export const SIP_REJECTION_HEADLINE = 'Your phone system rejected the call.';

export const SIP_REJECTION_ACTION =
  'Nothing was dialled through the normal phone network. Check the phone system settings in ' +
  'CallScribe settings, or ask your administrator.';
